/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable */
import React, { useContext } from 'react';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import Marquee from 'react-fast-marquee';
import Sensors from '../../assets/images/sensors.svg';
import sensorsLight from '../../assets/images/sensorsLight.svg';
import sensorsDark from '../../assets/images/sensorsDark.svg';
import themeSelected from './Context';

const TickerCarousel = props => {
  const doChange = () => {
    props.doChange();
  };
  const { theme } = useContext(themeSelected);

  return (
    <div key="ticker-carousel" className="ticker-carousel">
      <Carousel
        animationSpeed={500}
        autoPlay={5000}
        infinite
        stopAutoPlayOnHover
        centered
        value={props.value}
        onChange={doChange}
        dots
      >
        {props.data &&
          props.data.length > 0 &&
          props.data.map(e =>
            e.messageContent.length > 150 ? (
              <Marquee speed={100} key={e.messageId}>
                <img
                  src={theme === 'light' ? sensorsLight : sensorsDark}
                  alt="sensors"
                  className="mr-1"
                />
                <div onClick={() => props.openTickerDialog()}>
                  {e.messageContent}
                </div>
              </Marquee>
            ) : (
              <React.Fragment key={e.messageId}>
                <img
                  src={theme === 'light' ? sensorsLight : sensorsDark}
                  alt="sensors"
                  className="mr-1"
                />
                <div onClick={() => props.openTickerDialog()}>
                  {e.messageContent}
                </div>
              </React.Fragment>
            )
          )}
      </Carousel>
    </div>
  );
};

export default TickerCarousel;
